import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { isPlatformBrowser } from '@angular/common';
import { catchError, map } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { ClaimCounters } from '../../models/claim-counters.models';

@Injectable({
  providedIn: 'root',
})
// This service is used to get header statistics including start date and fact counters
export class HeaderStatsService {
  private isBrowser: boolean;

  constructor(
    private firestore: Firestore,
    @Inject(PLATFORM_ID) platformId: Object,
    private logger: LoggerService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  getStartDate(): Observable<string> {
    if (!this.isBrowser) {
      return of('');
    }

    return from(
      getDoc(doc(this.firestore, 'start_date', 'start_date')).then(docSnap => {
        if (docSnap.exists()) {
          return docSnap.data()['startDate'] || '';
        }
        return '';
      }),
    ).pipe(
      catchError(error => {
        this.logger.error('Error getting start date:', error);
        return of('');
      }),
    );
  }

  getFactCounters(): Observable<ClaimCounters> {
    if (!this.isBrowser) {
      return from(Promise.resolve({ true: 0, false: 0, bullshit: 0 }));
    }

    return from(
      getDoc(doc(this.firestore, 'claim_counters', 'claim_counters')).then(
        docSnap => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            return {
              false: data['falseCount'] || 0,
              true: data['trueCount'] || 0,
              bullshit: data['bullshitCount'] || 0,
            };
          }
          return { true: 0, false: 0, bullshit: 0 };
        },
      ),
    ).pipe(
      catchError(error => {
        this.logger.error('Error getting claim counters:', error);
        return from(Promise.resolve({ true: 0, false: 0, bullshit: 0 }));
      }),
    );
  }
}
